Vue.mixin({
    computed: {
        // documentHeight() {
        //     return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
        // },
        // windowHeight() {
        //     return window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
        // },
        // windowWidth() {
        //     return window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth
        // },
    },
    methods: {
        trans(key){
            return _.get(window.trans, key, key)
        },
    }
})